import { render, staticRenderFns } from "./IsProtectionMeasureDoneQuestion.vue?vue&type=template&id=e679be90&scoped=true"
import script from "./IsProtectionMeasureDoneQuestion.vue?vue&type=script&lang=ts"
export * from "./IsProtectionMeasureDoneQuestion.vue?vue&type=script&lang=ts"
import style0 from "./IsProtectionMeasureDoneQuestion.vue?vue&type=style&index=0&id=e679be90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e679be90",
  null
  
)

export default component.exports